import React from 'react';
import { X } from 'lucide-react';
import type { MarketReviewFilter } from '../../types/market-review';
import { formatDate } from '../../utils/dateUtils';

interface ActiveMarketReviewFiltersProps {
  filters: MarketReviewFilter;
  onRemoveFilter: (key: keyof MarketReviewFilter) => void;
  reviewTypeMap?: Record<string, string>;
}

export default function ActiveMarketReviewFilters({ 
  filters, 
  onRemoveFilter,
  reviewTypeMap = {}
}: ActiveMarketReviewFiltersProps) {
  const hasActiveFilters = Object.values(filters).some(Boolean);
  
  if (!hasActiveFilters) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {filters.lot && (
        <FilterTag
          label="Lot"
          value={filters.lot}
          onRemove={() => onRemoveFilter('lot')}
        />
      )}
      {filters.reviewType && (
        <FilterTag
          label="Review Type"
          value={reviewTypeMap[filters.reviewType] || filters.reviewType}
          onRemove={() => onRemoveFilter('reviewType')}
        />
      )}
      {filters.reviewDateAfter && (
        <FilterTag
          label="Review Date After"
          value={formatDate(filters.reviewDateAfter)}
          onRemove={() => onRemoveFilter('reviewDateAfter')}
        />
      )}
      {filters.reviewDateBefore && (
        <FilterTag
          label="Review Date Before"
          value={formatDate(filters.reviewDateBefore)}
          onRemove={() => onRemoveFilter('reviewDateBefore')}
        />
      )}
      {filters.nextReviewBefore && (
        <FilterTag
          label="Next Review Before"
          value={formatDate(filters.nextReviewBefore)}
          onRemove={() => onRemoveFilter('nextReviewBefore')}
        />
      )}
    </div>
  );
}

interface FilterTagProps {
  label: string;
  value: string;
  onRemove: () => void;
}

function FilterTag({ label, value, onRemove }: FilterTagProps) {
  return (
    <div className="flex items-center gap-1 text-sm bg-gray-100 text-gray-700 px-2 py-1 rounded-md">
      <span className="font-medium">{label}:</span>
      <span>{value}</span>
      <button
        onClick={onRemove}
        className="ml-1 p-0.5 hover:bg-gray-200 rounded-full"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
